<script lang="ts" setup>
import { t } from '@/Support/lang'
import { Menu, MenuButton } from '@headlessui/vue'
import {
  EllipsisVerticalIcon,
  EyeIcon,
  TrashIcon,
} from '@heroicons/vue/16/solid'
import MenuItemsDropdowns from '@/Components/App/Global/MenuItemsDropdown.vue'
import MenuItemDropdown from '@/Components/App/Global/MenuItemDropdown.vue'

const emit = defineEmits<{
  (e: 'load'): void
  (e: 'remove'): void
}>()
</script>
<template>
  <Menu v-slot="{ open }" as="div" class="inline-block text-left">
    <div>
      <MenuButton
        class="flex items-center text-neutral-400 hover:text-neutral-600 focus:outline-hidden"
      >
        <span class="sr-only">{{ t(open ? 'Close menu' : 'Open menu') }}</span>
        <EllipsisVerticalIcon class="h-5 w-5" aria-hidden="true" />
      </MenuButton>
    </div>

    <MenuItemsDropdowns>
      <div class="py-1 normal-case font-normal">
        <MenuItemDropdown
          :icon="EyeIcon"
          title="ai.query.menu.view-thread"
          @clicked="emit('load')"
        />
        <MenuItemDropdown
          :icon="TrashIcon"
          title="ai.query.menu.remove-thread"
          @clicked="emit('remove')"
        />
      </div>
    </MenuItemsDropdowns>
  </Menu>
</template>
